import { Box, Flex, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { ILexiconField } from '@publishing-engine/domain/models';
import LabelWithTooltip from './LabelWithTooltip';

interface Props {
  config: ILexiconField;
  icon?: IconDefinition;
  values?: string[];
  marginLeft?:string
}

const ReviewerPropertyRow = ({ config, icon, values,marginLeft }: Props) => {
  const displayValue = values?.length ? values.join(', ') : '-';

  return (
    <Flex>
      <Flex textStyle="textContext" alignItems={'flex-start'}  >
        {icon ? (
          <Box>
            <FontAwesomeIcon icon={icon} />
          </Box>
        ) : null}
        <LabelWithTooltip marginLeft={marginLeft} config={config} /> :
      </Flex>
      <Text
        textStyle="textContext"
        paddingLeft={1}
        wordBreak="break-word"
        minW={0}
        flex={1}
      >
        {displayValue}
      </Text>
    </Flex>
  );
};

export default ReviewerPropertyRow;
